import { ViewConfigTable } from "./ViewConfigTable"
import { styled } from "@mui/material/styles"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import { useAppDispatch, useAppSelector } from "../../util/hooks"
import { Typography, Box, CircularProgress } from "@mui/material"
import { closeDialog } from "./MaintenanceSlice"
import { ErrorBoundary } from "react-error-boundary"
import { NEW_PIPELINE_CONFIG } from "../../util/NewPipelineConfig"
import { CustomErrorMsg } from "../../components/CustomErrorMsg"
import { API_STATUS } from "../../util/StaticData"

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}))

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(1),
  position: "relative",
}))

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  zIndex: 100,
  color: theme.palette.grey[500],
  padding: 5,
  right: 8,
  top: 7,
}))

const ConfigContainer = styled("div")(({ theme }) => ({
  border: "1px solid #F0F1F3",
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
}))

export const ViewConfig = () => {
  const isModalOpen = useAppSelector((store) => store.maintenance.isModalOpen)
  const dispatch = useAppDispatch()
  const handleClose = () => {
    dispatch(closeDialog())
  }
  const data = useAppSelector((store) => store.maintenance.viewConfigData)

  const pipelineConfigStatus = useAppSelector(
    (store) => store.maintenance.pipelineConfig.status,
  )
  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isModalOpen}
      fullWidth={true}
      maxWidth={"xl"}
    >
      <StyledDialogTitle id="customized-dialog-title">
        Configurations
        <StyledIconButton aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </StyledIconButton>
      </StyledDialogTitle>
      <DialogContent>
        <ErrorBoundary fallback={<CustomErrorMsg />}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {data
              ? Object.keys(data).map((key: string) => {
                  return (
                    <ConfigContainer key={key}>
                      <Typography variant="redTableHeader"> {key} </Typography>
                      <ViewConfigTable
                        columns={Object.keys(data[key][0])}
                        mapper={Object.keys(data[key][0]).map((value) => {
                          return NEW_PIPELINE_CONFIG[key].find(
                            (obj: any) => obj.key === value,
                          ).label
                        })}
                        data={data[key]}
                      />
                    </ConfigContainer>
                  )
                })
              : ""}

            {pipelineConfigStatus === API_STATUS.LOADING ? (
              <Box display={"flex"} justifyContent={"center"}>
                <CircularProgress />
              </Box>
            ) : (
              ""
            )}
          </Box>
        </ErrorBoundary>
      </DialogContent>
      <DialogActions></DialogActions>
    </BootstrapDialog>
  )
}
